/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Custom steering prompt for the AI
 */
export type AssessmentRequestAdditionalInstructions = string | null;
